// extracted by mini-css-extract-plugin
export var deleteModal = "_de-0";